import { NavigatorYAxisBreaksOptions } from "highcharts";

export class FormParam {
  REQ_DATE: string;
  ALL: string;
  AM: any;
  WAITING: string;
  REQ_BY_NAME_ID: string;
  APPROVED: string;
  JOBTITLE_NO: number;
  DENIED: string;
  REQUISITIONS_FLAG: number;
  FILTER_TYPE: string;
  START_DATE: Date;
  AS_OF_DATE: Date;
  VAT_CHALLAN_START_DATE: Date;
  VAT_CHALLAN_END_DATE: Date;
  START_DATE2: Date;
  END_DATE: Date;
  SALES_ORDER: string;
  LC_START_DATE: Date;
  LC_END_DATE: Date;

  TRANSACTION_FROM_DATE: Date;
  TRANSACTION_TO_DATE: Date;
  TRANSACTION_ONLY: number;
  TRANSACTION_MODULE_NAME: string;
  TRANSACTION_MODULE_ID: string;
  TRANSACTION_MODULE_NO: number;
  APRV_SUBMIT: number;
  TO_DATE: Date;
  FROM_DATE: Date;
  FROM_DAYS: number;
  TO_DAYS: number;
  END_DATE2: Date;
  BANK_ACC_START_DATE: Date;
  BANK_ACC_END_DATE: Date;
  MATURITY_START_DATE: Date;
  MATURITY_END_DATE: Date;
  BANK_ACCEPT_DELAY_START_DATE: Date;
  BANK_ACCEPT_DELAY_END_DATE: Date;
  PAYMENT_DELAY_START_DATE: Date;
  PAYMENT_DELAY_END_DATE: Date;
  DC_CHECK: number;
  EXCLUE_CHECK: number;
  PAY_NO: number;
  PAY_ID: string;
  AVG_CONSUMPTION: string;
  CONSUMPTION_QTY: number;
  CATEGORY: string;
  REQ_NO: number;
  REQ_TYPE: number;
  DOCUMENT_ID: number;
  IN_REQ_NO: number;
  PREQ_NO: number;
  CREQ_NO: number;
  VAT_CHALLAN_NO: number;
  GROUP_SUPPLIER_NO: number;
  DAY: string;
  DAYNO: string;
  SUBMENU_ID: string;
  SUBMENU_ID2: string;
  SUBMENU_ID3: string;
  SO: string;
  REPORT_FORMAT: any;
  VIEW_TYPE: any;
  BU_NO: number;
  BU_NO_ALL: any;
  BU_NAME: string;
  BU_NAME_CUST: string;
  PEGP_NO: number;
  STORE_BU_NO: number;
  STOCK_VALUATION_TYPE: string;
  // STORE_BU_NO: number;
  CHK_BU_ALL: number;
  TO_BU_NO: number;
  RB_TYPE: string;
  COMPANY_NO: number;
  COMPANY_NAME: string;
  ITEM_NO: number;
  GROUP_ITEM_NO: number;
  GROUP_ITEM_NAME: string;
  DTL_NAME: string;
  ITEM_NAME_NO: number;
  STATUS: string;
  DATE_TYPE: string;
  WORK_TYPE: string;
  RECIEVE_TYPE: string;
  INVENTORY_TYPE: string;
  APPROVE_STATUS: any;
  PUR_REQ: number;
  STORE_GROUP_NO: number;
  GROUP_NO: number;
  STORE_GROUP_NAME: string;
  GROUP_NAME: string;
  WO_PENDING: number;
  SETTLEMENT: number;
  ITEM_NAME: string;
  ROOT_GRP_NAME: string;
  ITEM_ID: string;
  PENDING: string;
  PENDING_STATUS: string;
  SERVER_NAME: string;
  FORMAT_SHORT_NAME: string;
  DETAILS: string;
  IS_REPORT_TYPE: any;
  PREQ_ID: string;
  IS_SUPP_LIST_TYPE: number;
  SUPPLIER_ID: number;
  START_RANGE: number;
  SELECT_RANGE: [];
  END_RANGE: number;
  SUPPLIER: string;
  PER_ON: string;
  S_TYPE_NO: number;
  REP_OPTION: number;
  RETURN_LIST: number;
  RETURN_DETAILS: number;
  BILLRET_NO: number;
  WO_NO: number;
  PRIV_NO_FUND: number;
  PRIV_NO_BUDGET: number;
  METHOD: string;
  PRIV_NO_METHOD_NAME: number;
  PRIV_NO_DA: number;
  APP_PROCESSTYPE_NO: number;
  SUPPLIER_ACCOUNT_NOT_MAP: number;
  SUPPLIER_NO: number;
  REF_NO: number;
  BILL_NO: number;
  BILL_LIST: string;
  BILL_TYPE: string;
  BILL_TYPE_STATUS: string;
  IS_ITEM_PRICE: boolean;
  GATE_PASS_SAMMARY_REPORT: boolean;
  IS_DUE_ONLY: boolean;
  IS_WiTHOUT_LC_ONLY: boolean;
  IS_WITHOUT_BU: boolean;
  INCLUDE_WIP: number;

  SUPPLIER_NAME: string;
  PRIV_NO: number;
  PRIV_NO2: number;
  SUMMARY: number;
  LC_REQ: any;
  DOCTYPE_NAME: string;
  CUSTOMER_TYPE_NAME: string;
  SORT_NAME: string;
  DOCTYPE_NO: number;
  BANKDTL_NO: number;
  BATCH_NO: any;
  BATCH_NAME: any;
  BALANCE_QTY: number;
  BALANCE_QTY_GREATER_THAN: any;
  BALANCE_QTY_LESS_THAN: number;
  PURCONTRACT_NO: number;
  FILE_NO: number;
  VALUE: any;
  DOC_VALUE: string;
  CL_VALUE: string;
  REPORT_LIST_TYPE: string;
  KEY: string;
  COST_NO: number;
  WO_DATE: Date;
  WO_ID: string;
  PI: string;
  PI_DATE: Date;
  SUPPOFFER_NO: number;
  REPORT_TYPE: any;
  LETTER_TYPE: any;
  STATUS_TYPE: any;
  BANK_TYPE: any;
  LOOKUPDTL_NO: number;
  LOOKUP_NO: number;
  EMP_NO: number;
  SALES_PERSON_NO: number;
  EMP_NAME: string;
  EMP_NAME_ID: string;
  LOC_NO: number;
  SO_LIST: string;
  SO_NO: number;
  LO_ID: string;
  LO_NO: number;
  LOAN_NO: number;
  LOAN_ID: string;
  REPORT_NAME: string;
  LOAN_REQ: string;
  STORE_NAME: string;
  TO_STORE_NAME: string;
  STORE_TYPE: string;
  PURDOCUMENT_ID: string;
  TRN_ID: string;
  TRN_NO: number;
  TRNTYPE_NO: number;
  SO_FLAG: number;
  TRN_NAME: string;
  TRN_TYPE: string;
  TRN_TYPE_NO: number;
  CUSTOMER_TYPE_NO: number;
  MC_TRN: string;
  MC: number;
  OWN_WORK_ORDER_ONLY: number;
  WORK_ORDER_APPROVAL: number;
  PRINT_FORMAT: string;
  TYPE_ID: string;
  MANUAL: string;
  SYSTEM_GENERATED: string;
  REFERENCE: string;
  LC_FILE_NO: number;
  P_ACTIVE_STAT: any;
  PI_NO: any;
  PI_START_DATE: Date;
  PI_END_DATE: Date;
  CL_REPORTS: any;
  CL_SUPPLIER_WISE_REPORTS: any;
  CL_STATEMENT_REPORT: any;
  MENUFACTURER_NO: number;
  MENUFACTURER_SUPPLIER: string;
  DEFAULT: any;
  MANUFACTURER: any;
  ST_DATE: Date;
  EN_DATE: Date;
  OP_DATE: Date;
  MAX_END_DATE: Date;
  TYPE: any;
  LC_SUMMARY: any;
  LC_DOCUMENT_WISE: any;
  LC_REPORT: any;
  CNF_AGENT_ALIAS: string;
  CNF_AGENT_NAME: string;
  CNF_AGENT_NO: number;
  CNF_AGENCY_COMMISSION_BILL: number;
  HANDOVER_TRANSPORT_REPORT: number;
  REQ_STATUS: number;
  PAID: string;
  SC_NO: number;
  ACCEPT_STATUS: string;
  CUSTOMER_NO: number;
  CUSTOMER_NAME: string;
  CUSTOMER_ID: string;
  CONTRACT_NO: number;
  CONTRACT_NAME: string;
  INVOICE_NO: number;
  INVOICE_NAME: string;
  ISSUE_TYPE: string;
  ISSUE_ZERO: number;
  RCV_ZERO: number;
  SUPP_ZERO: number;
  PI_AM_NO: number;
  HUNDREAD: number;
  COMPANY_TYPE: number;
  PROCESS_TYPE_NO: number;
  GATE_PASS_TYPE: number;
  GATE_PASS_NO: number;
  GENGATERETURN_NO: number;
  ACTIVE_STATUS: number;
  TRANSFERED_STATUS: string;
  GATEPASS_STATUS: number;
  DO_NO: number;
  GROUP_STORE_NO: number;
  GROUP_STORE_NAME: string;
  SALES_TYPE_NO: number;
  DELIVERY_TYPE: string;
  ORDER_TYPE: string;
  REF_CUSTOMER: string;
  CHALLAN_NO: number;
  FORM_ID: string;
  SALESCONTRACT_NO: number;
  LC_NO: number;
  SUPPLIER_BILL_NO: number;
  BUDGET_NO: number;
  BUDGET_ID: string;
  RADIO_BUTTON_TYPE: any;
  RADIO_BUTTON_TYPE_2: any;
  ALLOWED: string;
  DISALLOWED: string;
  REVOCABLE: string;
  IRREVOCABLE: string;
  POST_TYPE: number;
  SI_NO: number;
  PI_ID: string;
  TRN_LIST: string;
  WORK_ORDER_NAME: string;
  WORK_ORDER_NO: string;
  TRANSACTION_TYPE_NO: number;
  REPORT_NO: number;
  LOAD_NO: number;
  LOAD_ID: string;
  BATCH_LOT: string;
  ROLL: any;
  RCV_DATE: Date;
  EXPIRY_DATE: Date;
  FIRST_NO: number;
  TOTAL_LOT: number;
  FALL_POINT: string;
  COUNT: number;
  LAST_NO: number;
  DESCR: string;
  HAZARD_STATUS: string;
  LOCATION_NO: number;
  LOCATION: string;
  NO_BATCH: any;
  START_BATCH: string;
  START_SERIAL: string;
  TOTAL_SERIAL: number;
  EXISTS_FLAG: any;
  SERIAL_NO: any;
  DTL_DESC: string;
  STORE: any;
  COST_NAME: string;
  ITEM_GROUP_NAME: string;
  ITEM_GROUP_NO: number;
  SRL_RANGE_FLAG: number;
  SERIAL_NO_ST: string;
  SERIAL_NO_EN: string;
  QNTY: any;
  SOURCE_TYPE: string;
  SOURCE_NO: number;
  POST_FLAG: number;
  tDotType: number;
  TRN_BU: number;
  TRN_BU_NAME: string;
  OWN_REQUISITIONS_ONLY: number;
  OWN_WO_ONLY: number;
  LOAN: number;
  STORE_NO: number;
  PROGRAM_NO: number;
  LOC_NAME: string;
  REQ_ID: string;
  RNTYPE_NAME: string;
  BU_NO_FROM: number;
  BU_NO_TO: number;
  SL_NO: number;
  LOCATION_DESCRIPTION: string;
  DESCRIPTION: string;
  TOTAL: any;
  ROLE: any;
  BATCH_QTY: any;
  SOURCE_REQUIRED: any;
  BANKREF: any;
  GATE_PASS: any;
  GATE_PASS_RETURN: any;
  CANCEL_GATE_PASS: any;
  REFERENCE_TYPE: any;
  DIRECT: any;
  REQUISITION: any;
  INTERNAL: any;
  EXTERNAL: any;
  ISSUE_STORE_NAME: string;
  ISSUE_BU_NO: number;
  LOAN_STATUS: string;
  SUBMENU_NAME_USER: string;
  BANK_NO: number;
  BANK_NAME: string;
  PI_TYPE_NO: number;
  LOT_NO: any;
  START_BARCH: any;
  NO_OF_BARCH: any;
  NO_OF_BATCH: any;
  SRART_SERIAL: any;

  SRATR_SERIAL: any;
  TOTAL_SERIAL_BARCH: any;
  TOTAL_SERIAL_BATCH: any;
  LOCATION_NAME: string;
  SL_COUNT: number;
  START_NO: number;
  END_NO: number;
  MFG_DATE: Date;
  BATCH_LOT_TOTAL: number;
  BATCH_EXPIRY_DATE: Date;
  BATCH_MANUFACTUER_DATE: Date;
  UOM_NO: number;
  UOM_SHORT: string;
  TR_UOM_NO: number;
  TR_UOM_SHORT: string;
  TO_CONVERT: number;
  RESULT: number;
  PRINT_COPY: any;
  PREQ_FROM_BU: any;
  GROUP_SUPPLIER_NAME: any;
  PREQ_FROM: any;
  PRDT_FROM: Date;
  PRDT_TO: Date;
  EXDT_FROM: Date;
  P_START_DATE: Date;
  P_END_DATE: Date;
  EXDT_TO: Date;
  REQ_BY: any;
  UNIT_TYPE: any;
  REQ_BY_NAME: string;
  MULTI_CODE: string;
  MULTI_ITEM_GROUP: [];
  MONTHLY_PURCHASE: string;
  COMPANY_WISE_PURCHASE: string;
  ITEM_WISE_MATRIX: string;
  GROUP_WISE_PURCHASE_REPORT: string;
  MONTHLY_PURCHASE_REPORT: string;
  TRN_END_DATE: Date;
  TRN_START_DATE: Date;
  TRAN_TYPE: string;
  RCV_TYPE: string;
  SUBITEM_OF: number;
  SRC_QTY: number;
  REPORT_GROUP_CHECK: number;
  REPORT_GROUP: string;
  TRANSACTION_ITEM_CHK: number;
  SUPPRESS_ZERO_CHK: number;
  BIN_NO: number;
  UNIT_VAL: number;
  RANGE_STOCK_FROM: string;
  RANGE_STOCK_TO: string;
  STOCK_REG: string;
  STOCK_AGING_TYPE: number;
  QUANTITY: number;
  AGING_ABOVE_GREATER_THAN_EQUAL: number;
  FROM_STORE: string;
  I_NAME: string;
  UNIT_COM: string;
  SUPPLIER_OFFER: string;
  ON_VALIDATION: boolean;
  EXCHANGE_RATE: string;
  CURRENCY: string;
  POST_DATE: Date;
  COMMENT: string;
  VEHICLE_NO: string;
  BEARER_NAME: string;
  BEARER_PHONE: string;
  POST: string;
  POST_CHECK: string;
  REMARKS: string;
  SUBMIT_BY_NAME: string;
  ASSET_LIFE: any;
  APRV_SUBMIT_DATE: Date;
  TOTAL_STOCK: string;
  SS_CREATOR: number;
  P_ITEM_QUALITY: string;
  QC_ID: string;
  PURGROUP_REFFILE_NO: string;
  PURGROUP_ID: string;
  PURGROUP_STATUS_NO: any;
  PURGROUP_NO: any;
  REQUISITION_TO: number;
  STATUS_DATE: any;

  constructor(options: any = {}) {
    this.REQ_DATE = options.REQ_DATE || new Date();
    this.STOCK_REG = options.STOCK_REG || "";
    this.APRV_SUBMIT = options.APRV_SUBMIT || 0;
    this.SUBMIT_BY_NAME = options.SUBMIT_BY_NAME || "";
    this.APRV_SUBMIT_DATE = options.APRV_SUBMIT_DATE
      ? new Date(options.APRV_SUBMIT_DATE)
      : null;
    this.SUPPLIER_OFFER = options.SUPPLIER_OFFER || "";
    this.JOBTITLE_NO = options.JOBTITLE_NO || null;
    this.UNIT_COM = options.UNIT_COM || "";
    this.I_NAME = options.I_NAME || "";
    this.ON_VALIDATION = options.STOCK_REG || "";
    this.ON_VALIDATION = options.ON_VALIDATION || false;
    this.RANGE_STOCK_TO = options.RANGE_STOCK_TO || "";
    this.REQ_BY_NAME_ID = options.REQ_BY_NAME_ID || "";
    this.UNIT_TYPE = options.UNIT_TYPE || "";
    this.RANGE_STOCK_FROM = options.RANGE_STOCK_FROM || "";
    this.TRANSACTION_MODULE_NAME = options.TRANSACTION_MODULE_NAME || "";
    this.TRANSACTION_MODULE_ID = options.TRANSACTION_MODULE_ID || "";
    this.TRANSACTION_MODULE_NO = options.TRANSACTION_MODULE_NO || null;
    this.SUPPRESS_ZERO_CHK = options.SUPPRESS_ZERO_CHK || 0;
    this.TRANSACTION_ITEM_CHK = options.TRANSACTION_ITEM_CHK || 0;
    this.REPORT_GROUP = options.REPORT_GROUP || "";
    this.REPORT_GROUP_CHECK = options.REPORT_GROUP_CHECK || 0;
    this.SRC_QTY = options.SRC_QTY || null;
    this.BIN_NO = options.BIN_NO || null;
    this.UNIT_VAL = options.UNIT_VAL || null;
    this.SUBITEM_OF = options.SUBITEM_OF || null;
    this.MC = options.MC || null;
    this.CONSUMPTION_QTY = options.CONSUMPTION_QTY || 0;
    this.GROUP_ITEM_NAME = options.GROUP_ITEM_NAME || "";
    this.AVG_CONSUMPTION = options.AVG_CONSUMPTION || "";
    this.MONTHLY_PURCHASE = options.MONTHLY_PURCHASE || "";
    this.COMPANY_WISE_PURCHASE = options.COMPANY_WISE_PURCHAS || "";
    this.ITEM_WISE_MATRIX = options.ITEM_WISE_MATRIX || "";
    this.GROUP_WISE_PURCHASE_REPORT = options.GROUP_WISE_PURCHASE_REPORT || "";
    this.MONTHLY_PURCHASE_REPORT = options.MONTHLY_PURCHASE_REPORT || "";
    this.REQ_BY_NAME = options.REQ_BY_NAME || "";
    this.TRAN_TYPE = options.TRAN_TYPE || "";
    this.MULTI_CODE = options.MULTI_CODE || "";
    this.MULTI_ITEM_GROUP = options.MULTI_ITEM_GROUP || [];
    this.SELECT_RANGE = options.SELECT_RANGE || [];
    this.REQ_BY = options.REQ_BY || null;
    this.EXDT_TO = options.EXDT_TO || null;
    this.EXDT_FROM = options.EXDT_FROM || null;
    this.P_START_DATE = options.P_START_DATE || null;
    this.P_END_DATE = options.P_END_DATE || null;
    this.PRDT_TO = options.PRDT_TO || null;
    this.PRDT_FROM = options.PRDT_FROM || null;
    this.PREQ_FROM_BU = options.PREQ_FROM_BU || "";
    this.PREQ_FROM = options.PREQ_FROM || "";
    this.PRINT_COPY = options.PRINT_COPY || "";
    this.RESULT = options.RESULT || null;
    this.TO_CONVERT = options.TO_CONVERT || null;
    this.TR_UOM_SHORT = options.TR_UOM_SHORT || "";
    this.HAZARD_STATUS = options.HAZARD_STATUS || "";
    this.TR_UOM_NO = options.TR_UOM_NO || null;
    this.UOM_SHORT = options.UOM_SHORT || "";
    this.UOM_NO = options.UOM_NO || null;
    this.BATCH_EXPIRY_DATE = options.BATCH_EXPIRY_DATE || null;
    this.BATCH_MANUFACTUER_DATE = options.BATCH_MANUFACTUER_DATE || null;
    this.BATCH_LOT_TOTAL = options.BATCH_LOT_TOTAL || null;
    this.MFG_DATE = options.MFG_DATE || null;
    this.TRANSACTION_ONLY = options.TRANSACTION_ONLY || 0;
    this.START_NO = options.START_NO || null;
    this.END_NO = options.END_NO || null;
    this.FROM_DAYS = options.FROM_DAYS || null;
    this.TO_DAYS = options.TO_DAYS || null;
    this.SL_COUNT = options.SL_COUNT || null;
    this.LOCATION_NAME = options.LOCATION_NAME || "";
    this.TOTAL_SERIAL_BARCH = options.TOTAL_SERIAL_BARCH || null;
    this.TOTAL_SERIAL_BATCH = options.TOTAL_SERIAL_BATCH || null;
    this.SRATR_SERIAL = options.SRATR_SERIAL || null;
    this.SRART_SERIAL = options.SRART_SERIAL || null;
    this.NO_OF_BARCH = options.NO_OF_BARCH || null;
    this.START_BARCH = options.START_BARCH || null;
    this.NO_OF_BATCH = options.NO_OF_BATCH || null;
    this.LOT_NO = options.LOT_NO || null;
    this.INTERNAL = options.INTERNAL || null;
    this.EXTERNAL = options.EXTERNAL || null;
    this.GATE_PASS = options.GATE_PASS || null;
    this.GATE_PASS_RETURN = options.GATE_PASS_RETURN || null;
    this.CANCEL_GATE_PASS = options.CANCEL_GATE_PASS || null;
    this.REFERENCE_TYPE = options.REFERENCE_TYPE || "";
    this.DIRECT = options.DIRECT || "";
    this.RCV_TYPE = options.RCV_TYPE || "";
    this.FROM_STORE = options.FROM_STORE || "";
    this.METHOD = options.METHOD || "";
    this.REQUISITION = options.REQUISITION || "";
    this.GROUP_SUPPLIER_NAME = options.GROUP_SUPPLIER_NAME || "";
    this.LOAN_STATUS = options.LOAN_STATUS || null;
    this.SUBMENU_NAME_USER = options.SUBMENU_NAME_USER || null;
    this.ISSUE_BU_NO = options.ISSUE_BU_NO || null;
    this.BANK_NO = options.BANK_NO || null;
    this.PI_TYPE_NO = options.PI_TYPE_NO || null;
    this.BANK_NAME = options.BANK_NAME || null;
    this.ISSUE_STORE_NAME = options.ISSUE_STORE_NAME || null;
    this.LAST_NO = options.LAST_NO || null;
    this.GROUP_SUPPLIER_NO = options.GROUP_SUPPLIER_NO || null;
    this.AM = options.AM || null;
    this.BATCH_QTY = options.BATCH_QTY || null;
    this.LOCATION_DESCRIPTION = options.LOCATION_DESCRIPTION || null;
    this.TOTAL = options.TOTAL || null;
    this.ROLE = options.ROLE || null;
    this.SL_NO = options.SL_NO || null;
    this.BU_NO_TO = options.BU_NO_TO || null;
    this.BU_NO_FROM = options.BU_NO_FROM || null;
    this.RNTYPE_NAME = options.RNTYPE_NAME || "";
    this.REQ_ID = options.REQ_ID || "";
    this.LOC_NAME = options.LOC_NAME || "";
    this.PROGRAM_NO = options.PROGRAM_NO || 0;
    this.STORE_NO = options.STORE_NO || 0;
    this.LOAN = options.LOAN || 0;
    this.OWN_REQUISITIONS_ONLY = options.OWN_REQUISITIONS_ONLY || 0;
    this.OWN_WO_ONLY = options.OWN_WO_ONLY || 0;
    this.POST_FLAG = options.POST_FLAG || null;
    this.SOURCE_NO = options.SOURCE_NO || null;
    this.SOURCE_TYPE = options.SOURCE_TYPE || null;
    this.QNTY = options.QNTY || null;
    this.SERIAL_NO_EN = options.SERIAL_NO_EN || null;
    this.SERIAL_NO_ST = options.SERIAL_NO_ST || null;
    this.SRL_RANGE_FLAG = options.SRL_RANGE_FLAG || null;
    this.ITEM_GROUP_NO = options.ITEM_GROUP_NO || null;
    this.ITEM_GROUP_NAME = options.ITEM_GROUP_NAME || null;
    this.COST_NAME = options.COST_NAME || null;
    this.STORE = options.STORE || null;
    this.STOCK_VALUATION_TYPE = options.STOCK_VALUATION_TYPE || "";
    this.SERIAL_NO = options.SERIAL_NO || null;
    this.TOTAL_SERIAL = options.TOTAL_SERIAL || null;
    this.START_SERIAL = options.START_SERIAL || null;
    this.START_BATCH = options.START_BATCH || null;
    this.NO_BATCH = options.NO_BATCH || null;
    this.LOCATION_NO = options.LOCATION_NO || null;
    this.LOCATION = options.LOCATION || null;
    this.DESCR = options.DESCR || null;
    this.COUNT = options.COUNT || 0;
    this.FALL_POINT = options.FALL_POINT || null;
    this.FIRST_NO = options.FIRST_NO || null;
    this.EXPIRY_DATE = options.EXPIRY_DATE || null;
    this.RCV_DATE = options.RCV_DATE || null;
    this.ROLL = options.ROLL || null;
    this.BATCH_LOT = options.BATCH_LOT || null;

    this.EXISTS_FLAG = options.EXISTS_FLAG || null;
    this.LOAD_ID = options.LOAD_ID || null;
    this.LOAD_NO = options.LOAD_NO || null;
    this.REPORT_NO = options.REPORT_NO || null;
    this.TRANSACTION_TYPE_NO = options.TRANSACTION_TYPE_NO || null;
    this.WORK_ORDER_NAME = options.WORK_ORDER_NAME || null;
    this.WORK_ORDER_NO = options.WORK_ORDER_NO || null;
    this.REPORT_NAME = options.REPORT_NAME || null;
    this.TRN_LIST = options.TRN_LIST || null;
    this.SC_NO = options.SC_NO || null;
    this.PI_ID = options.PI_ID || null;
    this.SI_NO = options.SI_NO || null;
    this.SALES_ORDER = options.SALES_ORDER || null;
    this.POST_TYPE = options.POST_TYPE || null;
    this.SO_FLAG = options.SO_FLAG || null;
    this.DC_CHECK = options.DC_CHECK || 0;
    this.EXCLUE_CHECK = options.EXCLUE_CHECK || 0;
    this.REVOCABLE = options.REVOCABLE || "";
    this.IRREVOCABLE = options.IRREVOCABLE || "";
    this.ALLOWED = options.ALLOWED || "";
    this.DISALLOWED = options.DISALLOWED || "";
    this.ALL = options.ALL || "";
    this.BUDGET_NO = options.BUDGET_NO || null;
    this.BUDGET_ID = options.BUDGET_ID || null;
    this.RADIO_BUTTON_TYPE = options.RADIO_BUTTON_TYPE || null;
    this.RADIO_BUTTON_TYPE_2 = options.RADIO_BUTTON_TYPE_2 || null;
    this.WAITING = options.WAITING || "";
    this.APPROVED = options.APPROVED || "";
    this.DENIED = options.DENIED || "";
    this.PURDOCUMENT_ID = options.PURDOCUMENT_ID || null;
    this.RB_TYPE = options.RB_TYPE || null;
    this.ITEM_NAME = options.ITEM_NAME || "";
    this.GROUP_ITEM_NAME = options.GROUP_ITEM_NAME || "";
    this.ROOT_GRP_NAME = options.ROOT_GRP_NAME || "";

    this.ITEM_ID = options.ITEM_ID || "";
    this.STATUS = options.STATUS || null;
    this.DATE_TYPE = options.DATE_TYPE || "";
    this.REQ_TYPE = options.REQ_TYPE || "";
    this.WORK_TYPE = options.WORK_TYPE || "";
    this.RECIEVE_TYPE = options.RECIEVE_TYPE || "";
    this.INVENTORY_TYPE = options.INVENTORY_TYPE || "";
    this.COMPANY_NO = options.COMPANY_NO || null;
    this.COMPANY_NAME = options.COMPANY_NAME || "";
    this.WO_PENDING = options.WO_PENDING || null;
    this.SETTLEMENT = options.SETTLEMENT || null;
    this.PUR_REQ = options.PUR_REQ || null;
    this.ITEM_NO = options.ITEM_NO || null;
    this.BANKREF = options.BANKREF || null;
    this.DOCUMENT_ID = options.DOCUMENT_ID || null;
    this.CHALLAN_NO = options.CHALLAN_NO || null;
    this.VAT_CHALLAN_NO = options.VAT_CHALLAN_NO || null;
    this.GROUP_ITEM_NO = options.GROUP_ITEM_NO || null;
    this.APPROVE_STATUS = options.APPROVE_STATUS || null;
    this.LOAN_REQ = options.LOAN_REQ || "";
    this.LOAN_NO = options.LOAN_NO || null;
    this.AGING_ABOVE_GREATER_THAN_EQUAL =
      options.AGING_ABOVE_GREATER_THAN_EQUAL || null;
    this.LOAN_ID = options.LOAN_ID || "";
    this.BATCH_NO = options.BATCH_NO || null;
    this.BATCH_NAME = options.BATCH_NAME || "";
    this.BALANCE_QTY = options.BALANCE_QTY || null;
    this.BALANCE_QTY_GREATER_THAN = options.BALANCE_QTY_GREATER_THAN || null;
    this.BALANCE_QTY_LESS_THAN = options.BALANCE_QTY_LESS_THAN || null;
    this.STOCK_AGING_TYPE = options.STOCK_AGING_TYPE || null;
    this.QUANTITY = options.QUANTITY || null;

    this.REQUISITIONS_FLAG = options.REQUISITIONS_FLAG || 0;
    this.FILTER_TYPE = options.FILTER_TYPE || "";
    this.START_DATE = options.START_DATE || null;
    this.AS_OF_DATE = options.AS_OF_DATE || null;
    this.VAT_CHALLAN_START_DATE = options.VAT_CHALLAN_START_DATE || new Date();
    this.VAT_CHALLAN_END_DATE = options.VAT_CHALLAN_END_DATE || new Date();
    this.TRN_END_DATE = options.TRN_END_DATE || null;
    this.TRN_START_DATE = options.TRN_START_DATE || null;
    this.START_DATE2 = options.START_DATE2 || new Date();
    this.END_DATE = options.END_DATE || null;
    this.LC_START_DATE = options.LC_START_DATE || new Date();
    this.LC_END_DATE = options.END_DATE || new Date();

    this.TRANSACTION_FROM_DATE = options.TRANSACTION_FROM_DATE || new Date();
    this.TRANSACTION_TO_DATE = options.TRANSACTION_TO_DATE || new Date();

    this.END_DATE2 = options.END_DATE2 || new Date();
    this.MAX_END_DATE = options.MAX_END_DATE || new Date();
    this.TO_DATE = options.TO_DATE || new Date();
    this.FROM_DATE = options.FROM_DATE || new Date();
    this.ST_DATE = options.ST_DATE ? new Date(options.ST_DATE) : null;
    this.EN_DATE = options.EN_DATE ? new Date(options.EN_DATE) : null;
    this.OP_DATE = options.OP_DATE ? new Date(options.OP_DATE) : null;
    this.BANK_ACC_START_DATE = options.BANK_ACC_START_DATE || new Date();
    this.BANK_ACC_END_DATE = options.BANK_ACC_END_DATE || new Date();
    this.MATURITY_START_DATE = options.MATURITY_START_DATE || new Date();
    this.MATURITY_END_DATE = options.MATURITY_END_DATE || new Date();
    this.BANK_ACCEPT_DELAY_START_DATE =
      options.BANK_ACCEPT_DELAY_START_DATE || new Date();
    this.BANK_ACCEPT_DELAY_END_DATE =
      options.BANK_ACCEPT_DELAY_END_DATE || new Date();
    this.PAYMENT_DELAY_START_DATE =
      options.PAYMENT_DELAY_START_DATE || new Date();
    this.PAYMENT_DELAY_END_DATE = options.PAYMENT_DELAY_END_DATE || new Date();
    this.REQ_NO = options.REQ_NO || null;
    this.IN_REQ_NO = options.IN_REQ_NO || null;
    this.TO_BU_NO = options.TO_BU_NO || null;
    this.PREQ_NO = options.PREQ_NO || null;
    this.CREQ_NO = options.CREQ_NO || null;
    this.BU_NO = options.BU_NO || null;
    this.BU_NO_ALL = options.BU_NO_ALL || null;
    this.BU_NAME = options.BU_NAME || null;
    this.BU_NAME_CUST = options.BU_NAME_CUST || null;
    this.STORE_BU_NO = options.STORE_BU_NO || null;
    this.CHK_BU_ALL = options.CHK_BU_ALL || null;
    this.DAY = options.DAY || "";
    this.DAYNO = options.DAYNO || null;
    this.SUBMENU_ID = options.SUBMENU_ID || "";
    this.VIEW_TYPE = options.VIEW_TYPE || "";
    this.SUBMENU_ID2 = options.SUBMENU_ID2 || "";
    this.SUBMENU_ID3 = options.SUBMENU_ID3 || "";
    this.REPORT_FORMAT = options.REPORT_FORMAT || null;
    this.PENDING = options.PENDING || "";
    this.PENDING_STATUS = options.PENDING_STATUS || "";
    this.SERVER_NAME = options.SERVER_NAME || "";
    this.DETAILS = options.DETAILS || "";
    this.DTL_NAME = options.DTL_NAME || "";
    this.FORM_ID = options.FORM_ID || "";
    this.IS_REPORT_TYPE = options.IS_REPORT_TYPE || "";
    this.PREQ_ID = options.PREQ_ID || "";
    this.IS_SUPP_LIST_TYPE = options.IS_SUPP_LIST_TYPE || null;
    this.ITEM_NAME_NO = options.ITEM_NAME_NO || null;
    this.PRIV_NO_FUND = options.PRIV_NO_FUND || null;
    this.PRIV_NO_BUDGET = options.PRIV_NO_BUDGET || null;
    this.PRIV_NO_METHOD_NAME = options.PRIV_NO_METHOD_NAME || null;
    this.PRIV_NO_DA = options.PRIV_NO_DA || null;
    this.APP_PROCESSTYPE_NO = options.APP_PROCESSTYPE_NO || null;
    this.FORMAT_SHORT_NAME = options.FORMAT_SHORT_NAME || null;
    this.SUPPLIER_ACCOUNT_NOT_MAP = options.SUPPLIER_ACCOUNT_NOT_MAP || 0;
    this.SUPPLIER_NO = options.SUPPLIER_NO || null;
    this.REF_NO = options.REF_NO || null;
    this.BILL_NO = options.BILL_NO || null;
    this.BILL_LIST = options.BILL_LIST || "";
    this.IS_ITEM_PRICE = options.IS_ITEM_PRICE || false;
    this.GATE_PASS_SAMMARY_REPORT = options.GATE_PASS_SAMMARY_REPORT || false;
    this.IS_DUE_ONLY = options.IS_DUE_ONLY || false;
    this.IS_WiTHOUT_LC_ONLY = options.IS_WiTHOUT_LC_ONLY || false;
    this.IS_WITHOUT_BU = options.IS_WITHOUT_BU || false;
    this.SUPPLIER_ID = options.SUPPLIER_ID || null;
    this.DO_NO = options.DO_NO || null;
    this.GROUP_STORE_NO = options.GROUP_STORE_NO || null;
    this.SALES_TYPE_NO = options.SALES_TYPE_NO || null;
    this.SUPPLIER = options.SUPPLIER || "";
    this.DELIVERY_TYPE = options.DELIVERY_TYPE || "";
    this.GROUP_STORE_NAME = options.GROUP_STORE_NAME || "";
    this.REF_CUSTOMER = options.REF_CUSTOMER || "";
    this.ORDER_TYPE = options.ORDER_TYPE || "";
    this.PER_ON = options.PER_ON || "";
    this.S_TYPE_NO = options.S_TYPE_NO || null;
    this.SUPPLIER_NAME = options.SUPPLIER_NAME || "";
    this.REP_OPTION = options.REP_OPTION || null;
    this.RETURN_LIST = options.RETURN_LIST || null;
    this.RETURN_DETAILS = options.RETURN_DETAILS || null;
    this.BILLRET_NO = options.BILLRET_NO || null;
    this.PRIV_NO = options.PRIV_NO || null;
    this.PRIV_NO2 = options.PRIV_NO2 || null;
    this.INCLUDE_WIP = options.INCLUDE_WIP || null;
    this.SUMMARY = options.SUMMARY || null;
    this.DOCTYPE_NAME = options.DOCTYPE_NAME || "";
    this.CUSTOMER_TYPE_NAME = options.CUSTOMER_TYPE_NAME || "";
    this.SORT_NAME = options.SORT_NAME || "";
    this.DOCTYPE_NO = options.DOCTYPE_NO || null;
    this.PURCONTRACT_NO = options.PURCONTRACT_NO || null;
    this.BANKDTL_NO = options.BANKDTL_NO || null;
    this.FILE_NO = options.FILE_NO || null;
    this.WO_NO = options.WO_NO || null;
    this.LC_REQ = options.LC_REQ || null;
    this.DOC_VALUE = options.DOC_VALUE || "";
    this.CL_VALUE = options.CL_VALUE || "";
    this.VALUE = options.VALUE || null;
    this.REPORT_LIST_TYPE = options.REPORT_LIST_TYPE || "";
    this.KEY = options.KEY || "";
    this.COST_NO = options.COST_NO || null;
    this.WO_DATE = options.WO_DATE || new Date();
    this.WO_ID = options.WO_ID || "";
    this.PI = options.PI || "";
    this.SO = options.SO || "";
    this.PI_DATE = options.PI_DATE || new Date();
    this.SUPPOFFER_NO = options.SUPPOFFER_NO || null;
    this.OWN_WORK_ORDER_ONLY = options.OWN_WORK_ORDER_ONLY || null;
    this.WORK_ORDER_APPROVAL = options.WORK_ORDER_APPROVAL || null;
    this.TRN_TYPE_NO = options.TRN_TYPE_NO || null;
    this.CUSTOMER_TYPE_NO = options.TYPE_NO || null;
    this.PRINT_FORMAT = options.PRINT_FORMAT || "";
    this.TYPE_ID = options.TYPE_ID || "";
    this.MANUAL = options.MANUAL || "";
    this.SYSTEM_GENERATED = options.SYSTEM_GENERATED || "";
    this.OWN_WORK_ORDER_ONLY = options.OWN_WORK_ORDER_ONLY || "";
    this.REPORT_TYPE = options.REPORT_TYPE || null;
    this.LETTER_TYPE = options.LETTER_TYPE || null;
    this.STATUS_TYPE = options.STATUS_TYPE || "";
    this.BANK_TYPE = options.BANK_TYPE || "";
    this.LOOKUPDTL_NO = options.LOOKUPDTL_NO || null;
    this.LOOKUP_NO = options.LOOKUP_NO || null;
    this.EMP_NO = options.EMP_NO || null;
    this.SALES_PERSON_NO = options.SALES_PERSON_NO || null;
    this.EMP_NAME = options.EMP_NAME || null;
    this.EMP_NAME_ID = options.EMP_NAME_ID || null;
    this.LOC_NO = options.LOC_NO || null;
    this.STORE_NAME = options.STORE_NAME || "";
    this.TO_STORE_NAME = options.TO_STORE_NAME || "";
    this.STORE_TYPE = options.STORE_TYPE || "";

    this.TRN_ID = options.TRN_ID || "";
    this.TRN_NO = options.TRN_NO || null;
    this.SO_NO = options.SO_NO || null;
    this.SO_LIST = options.SO_LIST || null;
    this.TRNTYPE_NO = options.TRNTYPE_NO || null;
    this.TRN_NAME = options.TRN_NAME || "";
    this.TRN_TYPE = options.TRN_TYPE || "";
    this.SL_NO = options.SL_NO || "";
    this.REFERENCE = options.REFERENCE || "";
    this.LC_FILE_NO = options.LC_FILE_NO || null;
    this.P_ACTIVE_STAT = options.P_ACTIVE_STAT || "";
    this.PI_NO = options.PI_NO || null;
    this.PI_START_DATE = options.PI_START_DATE || new Date();
    this.PI_END_DATE = options.PI_END_DATE || new Date();
    this.CL_REPORTS = options.CL_REPORTS || "";
    this.CL_SUPPLIER_WISE_REPORTS = options.CL_SUPPLIER_WISE_REPORTS || "";
    this.CL_STATEMENT_REPORT = options.CL_STATEMENT_REPORT || "";
    this.MENUFACTURER_NO = options.MENUFACTURER_NO || null;
    this.MENUFACTURER_SUPPLIER = options.MENUFACTURER_SUPPLIER || "";
    this.DEFAULT = options.DEFAULT || "";
    this.MANUFACTURER = options.MANUFACTURER || "";
    this.TYPE = options.TYPE || "";
    this.LC_SUMMARY = options.LC_REPORT || "";
    this.LC_DOCUMENT_WISE = options.LC_REPORT || "";
    this.LC_REPORT = options.LC_REPORT || "";
    this.CNF_AGENT_ALIAS = options.CNF_AGENT_ALIAS || "";
    this.CNF_AGENT_NAME = options.CNF_AGENT_NAME || "";
    this.CNF_AGENT_NO = options.CNF_AGENT_NO || "";
    this.CNF_AGENCY_COMMISSION_BILL =
      options.CNF_AGENCY_COMMISSION_BILL || null;
    this.HANDOVER_TRANSPORT_REPORT = options.HANDOVER_TRANSPORT_REPORT || null;
    this.CATEGORY = options.CATEGORY || null;
    this.LC_REPORT = options.LC_REPORT || "";
    this.PAID = options.PAID || "";
    this.ACCEPT_STATUS = options.ACCEPT_STATUS || "";
    this.REQ_STATUS = options.REQ_STATUS || null;
    this.START_RANGE = options.START_RANGE || null;
    this.END_RANGE = options.END_RANGE || null;
    this.CUSTOMER_NO = options.CUSTOMER_NO || null;
    this.STORE_GROUP_NO = options.STORE_GROUP_NO || null;
    this.GROUP_NO = options.GROUP_NO || null;
    this.STORE_GROUP_NAME = options.STORE_GROUP_NAME || "";
    this.GROUP_NAME = options.GROUP_NAME || "";
    this.CUSTOMER_NAME = options.CUSTOMER_NAME || "";
    this.CUSTOMER_ID = options.CUSTOMER_ID || "";
    this.CONTRACT_NO = options.CONTRACT_NO || null;
    this.CONTRACT_NAME = options.CONTRACT_NAME || "";
    this.INVOICE_NO = options.INVOICE_NO || null;
    this.INVOICE_NAME = options.INVOICE_NAME || "";
    this.ISSUE_TYPE = options.ISSUE_TYPE || "";
    this.PI_AM_NO = options.PI_AM_NO || null;
    this.ISSUE_ZERO = options.ISSUE_ZERO || null;
    this.SUPP_ZERO = options.SUPP_ZERO || null;
    this.RCV_ZERO = options.RCV_ZERO || null;
    this.HUNDREAD = options.HUNDREAD || null;
    this.COMPANY_TYPE = options.COMPANY_TYPE || null;
    this.PROCESS_TYPE_NO = options.PROCESS_TYPE_NO || null;
    this.GATE_PASS_TYPE = options.GATE_PASS_TYPE || null;
    this.GATE_PASS_NO = options.GATE_PASS_NO || null;
    this.GENGATERETURN_NO = options.GENGATERETURN_NO || null;
    this.ACTIVE_STATUS = options.ACTIVE_STATUS || null;
    this.GATEPASS_STATUS = options.GATEPASS_STATUS || null;
    this.SALESCONTRACT_NO = options.SALESCONTRACT_NO || null;
    this.LC_NO = options.LC_NO || null;
    this.PAY_ID = options.PAY_ID || null;
    this.PAY_NO = options.PAY_NO || null;
    this.BILL_TYPE = options.BILL_TYPE || null;
    this.BILL_TYPE_STATUS = options.BILL_TYPE_STATUS || null;
    this.LO_NO = options.LO_NO || null;
    this.LO_ID = options.LO_ID || null;
    this.BUDGET_ID = options.BUDGET_ID || null;
    this.BUDGET_NO = options.BUDGET_NO || null;
    this.SUPPLIER_BILL_NO = options.SUPPLIER_BILL_NO || null;
    this.tDotType = options.tDotType || null;
    this.TRN_BU = options.TRN_BU || null;
    this.TRN_BU_NAME = options.TRN_BU_NAME || "";
    this.TOTAL = options.TOTAL || null;
    this.PEGP_NO = options.PEGP_NO || null;
    this.EXCHANGE_RATE = options.EXCHANGE_RATE || null;
    this.CURRENCY = options.CURRENCY || null;
    this.POST_DATE = options.POST_DATE || null;
    this.COMMENT = options.COMMENT || null;
    this.VEHICLE_NO = options.VEHICLE_NO || null;
    this.BEARER_NAME = options.BEARER_NAME || null;
    this.BEARER_PHONE = options.BEARER_PHONE || null;
    this.POST = options.POST || null;
    this.POST_CHECK = options.POST_CHECK || null;
    this.REMARKS = options.REMARKS || null;
    this.ASSET_LIFE = options.ASSET_LIFE || null;
    this.SS_CREATOR = options.SS_CREATOR || null;
    this.TOTAL_STOCK = options.TOTAL_STOCK || "";
    this.DESCRIPTION = options.DESCRIPTION || null;
    this.DTL_DESC = options.DTL_DESC || null;
    this.P_ITEM_QUALITY = options.P_ITEM_QUALITY || null;
    this.QC_ID = options.QC_ID || null;
    this.PURGROUP_REFFILE_NO = options.PURGROUP_REFFILE_NO || null;
    this.PURGROUP_ID = options.PURGROUP_ID || null;
    this.PURGROUP_STATUS_NO = options.PURGROUP_STATUS_NO || null;
    this.PURGROUP_NO = options.PURGROUP_NO || null;
    this.REQUISITION_TO = options.REQUISITION_TO || null;
    this.STATUS_DATE = options.STATUS_DATE || null;
  }
}
